export default {
  as: require("../icons/regions/as.png"),
  am: require("../icons/regions/am.png"),
  eu: require("../icons/regions/eu.png"),
  sa: require("../icons/regions/sa.png"),
  me: require("../icons/regions/me.png"),
  oc: require("../icons/regions/oc.png"),
  af: require("../icons/regions/af.png"),
  na: require("../icons/regions/na.png"),
  gl: require("../icons/regions/gl.png"),
  cn: require("../icons/regions/cn.png"),
  usca: require("../icons/regions/usca.png"),
  aunz: require("../icons/regions/aunz.png"),
  cnjpkr: require("../icons/regions/cnjpkr.png"),
  sgmyth: require("../icons/regions/sgmyth.png"),
  cb: require("../icons/regions/cb.png"),

  as12: require("../icons/regions/as12.png"),
  as20: require("../icons/regions/as20.png"),
  as7: require("../icons/regions/as7.png"),
  eu30: require("../icons/regions/eu30.png"),
  asp20: require("../icons/regions/asp20.png"),
  ba: require("../icons/regions/ba.png"),
  bl: require("../icons/regions/bl.png"),
  ca: require("../icons/regions/ca.png"),
  ch: require("../icons/regions/ch.png"),
  gu: require("../icons/regions/gu.png"),
  mena: require("../icons/regions/mena.png"),
  eea: require("../icons/regions/eea.png"),
  generic: require("../icons/flags/world.png"),
};
